<!-- src/views/category.vue -->
<template>
  <div class="category">
    <div class="tabs">
      <van-tabs
        swipeable
        animated
        v-model="activeName"
        color="#FF7A3E"
        line-width="50px"
        line-height="3px"
        @change="tabChange"
      >
        <van-tab title="类型" name="GAME_TYPE">
          <img
            class="world-mouth"
            src="@/assets/images/icon-mouth.png"
            alt=""
            :style="{ top: -scrollPosition + 12.5 + 'px' }"
            @click="wordMonthChange"
          />
          <van-tree-select
            :height="`100vh - 186px`"
            :items="items"
            :main-active-index.sync="typeActive"
            ref="treeSelect"
            @click-nav="categoryChange"
          >
            <template #content>
              <van-list
                v-model="loading"
                :finished="finished"
                finished-text="暂无更多数据"
                @load="onLoad"
              >
                <div class="game-list">
                  <div class="game-item" v-for="(info, i) in gameList" :key="i">
                    <div class="game-item-content" @click="jumpDetail(info)">
                      <img class="game-logo" :src="info.logoUrl" alt="" />
                      <div class="game-info">
                        <div class="game-info-title">
                          <h1>{{ info.gameName }}</h1>
                          <span>{{ info.discount }}</span>
                        </div>
                        <div class="game-info-desc">
                          <div class="game-info-gift">
                            <span v-if="info.wealf">福利</span>
                            <span v-if="!info.wealf && info.havaGift == 1">礼包</span>
                            <span v-if="info.isBTgame">变态特权</span>
                            <span v-if="info.waterMark == 1">专属折扣</span>
                            <span
                              v-if="
                                info.havaGift == 0 &&
                                !info.isBTgame &&
                                !info.wealf &&
                                info.waterMark == 0
                              "
                              >{{ info.title }}</span
                            >
                          </div>
                          <div class="star" v-if="info.starInfo">
                            <img
                              :key="star"
                              v-for="star in info.starInfo.allStar"
                              src="@/assets/images/star_all.png"
                              alt=""
                            />
                            <img
                              :key="star"
                              v-for="star in info.starInfo.halfStarStar"
                              src="@/assets/images/star_half.png"
                              alt=""
                            />
                          </div>
                        </div>
                        <div class="game-tag">
                          <span v-for="tag in info.formatGameType" :key="tag">{{
                            tag
                          }}</span>
                          <span class="other-tag">{{
                            info.openServerDate
                          }}</span>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="game-item-operate">
                      <span @click="doOperate(info, 'recharge')">充值</span>
                      <span @click="doOperate(info, 'download')">下载</span>
                    </div> -->
                    <operateBtns :gameInfo="info" @doOperate="doOperate" />
                  </div>
                </div>
              </van-list>
            </template>
          </van-tree-select>
        </van-tab>
        <van-tab title="题材" name="GAME_THEME">
          <img
            class="world-mouth"
            src="@/assets/images/icon-mouth.png"
            alt=""
            :style="{ top: -scrollPosition + 12.5 + 'px' }"
            @click="wordMonthChange"
          />
          <van-tree-select
            :height="`100vh - 186px`"
            :items="items"
            :main-active-index.sync="themeActive"
            ref="treeSelect"
            @click-nav="categoryChange"
          >
            <template #content>
              <van-list
                v-model="loading"
                :finished="finished"
                finished-text="暂无更多数据"
                @load="onLoad"
              >
                <div class="game-list">
                  <div
                    class="game-item"
                    v-for="(info, i) in gameList"
                    :key="i"
                  >
                    <div class="game-item-content" @click="jumpDetail(info)">
                      <img class="game-logo" :src="info.logoUrl" alt="" />
                      <div class="game-info">
                        <div class="game-info-title">
                          <h1>{{ info.gameName }}</h1>
                          <span>{{ info.discount }}</span>
                        </div>
                        <div class="game-info-desc">
                          <div class="game-info-gift">
                            <span v-if="info.wealf">福利</span>
                            <span v-if="!info.wealf && info.havaGift == 1">礼包</span>
                            <span v-if="info.isBTgame">变态特权</span>
                            <span v-if="info.waterMark == 1">专属折扣</span>
                            <span
                              v-if="
                                info.havaGift == 0 &&
                                !info.isBTgame &&
                                !info.wealf &&
                                info.waterMark == 0
                              "
                              >{{ info.title }}</span
                            >
                          </div>
                          <div class="star" v-if="info.starInfo">
                            <img
                              :key="star"
                              v-for="star in info.starInfo.allStar"
                              src="@/assets/images/star_all.png"
                              alt=""
                            />
                            <img
                              :key="star+999"
                              v-for="star in info.starInfo.halfStar"
                              src="@/assets/images/star_half.png"
                              alt=""
                            />
                          </div>
                        </div>
                        <div class="game-tag">
                          <span v-for="tag in info.formatGameType" :key="tag">{{
                            tag
                          }}</span>
                          <span class="other-tag">{{
                            info.openServerDate
                          }}</span>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="game-item-operate">
                      <span @click="doOperate(info, 'recharge')">充值</span>
                      <span @click="doOperate(info, 'download')">下载</span>
                    </div> -->
                    <operateBtns :gameInfo="info" @doOperate="doOperate" />
                  </div>
                </div>
              </van-list>
            </template>
          </van-tree-select>
        </van-tab>

        
      </van-tabs>
      <div class="recent-open" @click="recentOpenHandle">
        <img :src="checked ? require('@/assets/images/ic_filter_2.png') : require('@/assets/images/ic_filter_2_normal.png')" alt="">
        <span>开服</span>
      </div>
    </div>
    <gamePlatPopup
      v-if="gamePlatPopupVisible"
      v-model="gamePlatPopupVisible"
      :btnType="btnType"
      :gameInfo="gameInfo"
    ></gamePlatPopup>
  </div>
</template>

<script>
import { requestMethods } from "@m/api";
import gamePlatPopup from "../../components/GamePlatPopup.vue";
import { mapGetters } from "vuex";
import operateBtns from "@/components/OperateBtns.vue"
export default {
  name: "categoryPage",
  components: {
    gamePlatPopup,
    operateBtns
  },
  data() {
    return {
      activeName: "GAME_TYPE",
      items: [],
      active: 0,
      typeActive: 0,
      themeActive: 0,
      gameList: [],
      loading: false,
      finished: false,
      location: "PUBLIC_PARISE",
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
      scrollPosition: null,
      gamePlatPopupVisible: false,
      gameInfo: {},
      btnType: "",
      checked: '',
      choseItem: {},
      typeChoseItem: {},
      themeChoseItem: {}
    };
  },
  computed: {
    ...mapGetters(["isLogin", "uuid"]),
  },
  async mounted() {
    await this.gameTypeAndThemeQr();
    this.handleSelectItemNavScroll();
  },
  methods: {
    async onLoad() {
      this.loading = true;
      const { data, totalCount } = await this.gameListQr();

      this.gameList = [...this.gameList, ...data];
      this.totalCount = totalCount;
      this.totalPage = Math.ceil(this.totalCount / this.pageSize);
      // 数据全部加载完成
      if (this.currentPage >= this.totalPage) {
        this.finished = true;
      }
      this.currentPage += 1;

      this.loading = false;
    },

    /**
     * 根据分类查询游戏列表
     */
    async gameListQr() {
      let code = this.location == 'PUBLIC_PARISE' ? 'GAME_TYPE' : this.activeName
      try {
        const { data, totalCount } = await requestMethods(
          "/modules/web/game/queryGameByTypeOrTheme.htm",
          "post",
          {
            code: code,
            value: this.location,
            searchParams: JSON.stringify({
              recentOpen: this.checked ? '1' : ''
            }),
            uuid: this.uuid,
            currentPage: this.currentPage,
            pageSize: this.pageSize,
          }
        );
        let list = this.gameInit(data);
        return {
          data: list,
          totalCount: totalCount
        }
        // this.gameList.push(...list);
        // this.totalCount = totalCount;
      } catch (error) {
        this.$toast(err.message);
      }
    },

    /**
     * 查询游戏类型和题材的分类列表
     */
    async gameTypeAndThemeQr() {
      try {
        const { data } = await requestMethods(
          "/modules/web/game/queryGameTypeAndTheme.htm",
          "post",
          {
            typeCode: this.activeName,
          }
        );
        let list = data.filter((t) => t.itemCode != "PUBLIC_PARISE");
        this.items = list.map((e) => {
          return {
            text: e.itemValue,
            value: e.itemCode,
          };
        });
        this.items.unshift({
          text: "",
          value: "PUBLIC_PARISE",
        },
        {
          text: "全部",
          value: "",
        });
      } catch (error) {
        this.$toast(err.message);
      }
    },

    recentOpenHandle() {
      this.checked = !this.checked

      this.resetList(); // 重置数据
      this.onLoad(); // 重新加载第一页数据
    },

    resetList() {
      this.currentPage = 1; // 重置页码为第一页
      this.finished = false; // 重置 finished 状态
      this.gameList = []; // 清空当前列表
      this.totalCount = 0;
    },

    /**
     * 点击分类
     */
    categoryChange() {
      if(this.activeName == 'GAME_TYPE') {
        this.typeChoseItem = this.items[this.typeActive];
        this.active = this.typeActive
      } else {
        this.themeChoseItem = this.items[this.themeActive];
        this.active = this.themeActive
      }
      this.choseItem = this.items[this.active];
      this.location = this.choseItem.value;
      this.currentPage = 1;
      this.finished = false;
      this.loading = true;
      this.gameList = [];
      this.onLoad();
    },

    /**
     * 口碑榜图片点击
     */
    wordMonthChange() {
      if(this.activeName == 'GAME_TYPE') {
        this.typeActive = 0
      } else {
        this.themeActive = 0
      }
      this.location = "PUBLIC_PARISE";
      this.currentPage = 1;
      this.finished = false;
      this.loading = true;
      this.gameList = [];
      this.onLoad();
    },

    /**
     * 类型题材标签切换
     */
    async tabChange() {
      await this.gameTypeAndThemeQr();
      this.handleSelectItemNavScroll();
      
      if(this.activeName == 'GAME_TYPE') {
        this.typeChoseItem = this.items[this.typeActive];
        this.location = this.typeChoseItem.value;
      } else {
        this.themeChoseItem = this.items[this.themeActive];
        this.location = this.themeChoseItem.value;
      }
      
      // this.location = "PUBLIC_PARISE";
      this.finished = false;
      this.currentPage = 1;
      this.loading = true;
      this.gameList = [];
      this.onLoad();
    },

    doOperate(scope, chennel) {
      // if(!this.isLogin) {
      //   this.$router.push('/login')
      //   return
      // }
      this.btnType = chennel == "recharge" ? "00" : "01";
      this.gameInfo = {
        gameName: scope.gameName,
        gameId: scope.id
      }
      this.gamePlatPopupVisible = true;
    },

    /**
     * 跳转游戏详情
     */
    jumpDetail(info) {
      this.$router.push({ path: "/detail", query: { gameId: info.id } });
    },

    // 计算nav滚动高度
    handleSelectItemNavScroll() {
      let index = this.activeName == "GAME_TYPE" ? 0 : 1;
      const scrollableElement = document.getElementsByClassName(
        "van-tree-select__nav"
      )[index];

      // 添加滚动事件监听器
      scrollableElement.addEventListener("scroll", this.handleScroll);
    },

    handleScroll() {
      let index = this.activeName == "GAME_TYPE" ? 0 : 1;
      const scrollableElement = document.getElementsByClassName(
        "van-tree-select__nav"
      )[index];
      this.scrollPosition = scrollableElement.scrollTop;
    },

    gameInit(list) {
      this.setGameTag(list);
      this.setGameStar(list);
      return list;
    },
    /**
     * 处理游戏标签和开服信息显示
     */
    setGameTag(list) {
      list.forEach((g) => {
        let formatGameType = [];
        if (g.themeNamesList && g.themeNamesList.length) {
          let isBTgame = g.themeNamesList.includes("BT游戏");
          let hasKouBeiBangTag = g.themeNamesList.includes("口碑榜");
          let hasTeJiaTag = g.themeNamesList.includes("特价");
          g.isBTgame = isBTgame;
          if (hasKouBeiBangTag && hasTeJiaTag) {
            formatGameType.push("口碑榜");
            formatGameType.push("特价");
          } else if (!hasKouBeiBangTag && !hasTeJiaTag) {
            formatGameType.push(...g.themeNamesList.slice(0, 2));
          } else if (hasKouBeiBangTag || hasTeJiaTag) {
            if (hasKouBeiBangTag) {
              formatGameType.push("口碑榜");
            }
            if (hasTeJiaTag) {
              formatGameType.push("特价");
            }
            if (g.themeNamesList.length > 0) {
              let filterArr = g.themeNamesList.filter(
                (e) => e != "口碑榜" && e != "特价"
              );
              formatGameType.push(filterArr[0]);
            }
          }
        }
        g.formatGameType = formatGameType;
      });
      return list;
    },

    /**
     * 处理游戏星标
     */
    setGameStar(list) {
      list.forEach((k) => {
        let level = Number(k.gamehotlevel);
        if (level == 0) {
          //不设置
        } else if (level == 1) {
          k.starInfo = { allStar: 0, halfStar: 1 };
        } else if (level == 2) {
          k.starInfo = { allStar: 1, halfStar: 0 };
        } else if (level == 3) {
          k.starInfo = { allStar: 1, halfStar: 1 };
        } else if (level == 4) {
          k.starInfo = { allStar: 2, halfStar: 0 };
        } else if (level == 5) {
          k.starInfo = { allStar: 2, halfStar: 1 };
        } else {
          k.starInfo = { allStar: 3, halfStar: 0 };
        }
      });
      return list;
    },
  },
  beforeDestroy() {
    // 解绑事件
    const elements = document.getElementsByClassName("van-tree-select__nav");
    if (elements.length > 0) {
      elements.forEach((e) => {
        e.removeEventListener("scroll", this.handleScroll);
      });
    }
  },
};
</script>

<style lang="scss">
.category {
  .van-tabs__nav {
    width: 600px;
    margin: 0 auto;
  }
  .van-tabs--line .van-tabs__wrap {
    height: 88px;
  }
  .van-tree-select__content {
    flex: 4;
  }
  .van-tab__text {
    font-weight: 400;
    font-size: 32px;
    color: #414141;
    line-height: 45px;
  }
  .van-tab--active .van-tab__text {
    color: #ff7a3e;
    font-weight: 600;
  }
  .van-sidebar-item {
    height: 90px;
    line-height: 90px;
    text-align: center;
  }
  .van-sidebar-item--select .van-sidebar-item__text {
    color: #ff7a3e;
  }
  .van-sidebar-item__text {
    font-weight: 400;
    font-size: 26px;
    color: #000000;
  }
  .van-tree-select__nav-item {
    padding: 0;
  }
  .van-sidebar-item--select::before {
    height: 90px;
    width: 6px;
    background-color: #ff7a3e;
  }
  .van-tree-select {
    height: calc(100vh - 186px);
  }
  .van-list__finished-text {
    font-size: 24px;
  }
  .van-loading__text {
    font-size: 24px;
  }
  .van-tab__pane {
    position: relative;
  }
  .world-mouth {
    width: 113px;
    height: 30px;
    position: absolute;
    left: 22px;
    top: 0px;
    z-index: 99;
  }
  .game-list {
    padding: 30px;
  }
  .game-item {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 30px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  .game-item-content {
    display: flex;
    align-items: center;

    .game-logo {
      width: 132px;
      height: 132px;
      margin-right: 20px;
    }
    .game-info {
      .game-info-title {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        h1 {
          max-width: 180px;
          font-weight: 600;
          font-size: 32px;
          color: #000000;
          line-height: 45px;
          margin-right: 6px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        span {
          display: block;
          padding: 5px 5px;
          font-weight: 600;
          font-size: 22px;
          color: #ffffff;
          height: 30px;
          background: #ff7a3e;
          border-radius: 4px;
        }
      }
      .game-info-desc {
        width: 280px;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        .game-info-gift {
          span {
            padding: 4px 12px;
            background: #f8f8f8;
            border-radius: 4px;
            border: 1px solid #f8f8f8;
            font-weight: 500;
            font-size: 18px;
            color: #a2a2a2;
            margin-right: 8px;
          }
        }
        .star {
          display: flex;
          align-items: center;
          img {
            width: 24px;
            margin-right: 8px;
          }
        }
      }
      .game-tag {
        span {
          padding: 2px 6px;
          // background: #f8f8f8;
          border-radius: 22px;
          border: 0px solid #d2d2d2;
          font-weight: 600;
          font-size: 20px;
          color: #a2a2a2;
          // margin-right: 18px;
        }
        .other-tag {
          color: #ffbe70;
        }
      }
    }
  }

  .game-item-operate {
    span {
      display: block;
      width: 105px;
      height: 50px;
      border-radius: 25px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 28px;
      line-height: 50px;
      text-align: center;

      &:first-child {
        color: #ffffff;
        background: #ff7a3e;
        margin-bottom: 23px;
      }
      &:last-child {
        border: 2px solid #ff7a3e;
        color: #ff7a3e;
      }
    }
  }

  .recent-open {
    position: absolute;
    top: 34px;
    right: 32px;
    display: flex;
    align-items: center;

    img {
      width: 24px;
      height: 24px;
      margin-right: 4px;
    }
    span {
      font-size: 24px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/category/index.vue